import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import objectHash from 'object-hash';

var apply = function apply(fn, context) {
  return context && fn(context);
};

var dashToCamel = function dashToCamel(str) {
  return str.replace(/-([a-zA-Z])/g, function (m) {
    return m[1].toUpperCase();
  });
};

var identity = function identity(x) {
  return x;
};

var shapeMatcher = /<(path|polygon|rect)[\s\S]*?(?=\/>)/g; // `spaceSplitter` matches spaces in a string that are not within a quotation.
// See https://regex101.com/r/5I209k/4

var spaceSplitter = /\s(?=(?:[^"]*"[^"]*")*[^"]*$)/g;
var styleMatcher = /<style>([\s\S]*)<\/style>/;
var viewBoxMatcher = /<svg [\s\S]*?viewBox="(.*?)"[\s\S]*?>/;
/**
 * assignOver - assign a value to the key of a target object, unless both the
 * data to assign and the existing value within `target` are objects, in which
 * case the data will be shallowly merged.
 */

var assignOver = function assignOver(target, key, data) {
  if (target[key] && typeof target[key] === 'object' && typeof data === 'object') {
    target[key] = Object.assign({}, target[key], data);
  } else {
    target[key] = data;
  }
};
/**
 * objectify - higher-order function; returns a function of a string `context`
 * which converts the string to a Javascript object.
 */


export var objectify = function objectify(infix, suffix, getKey, getValue) {
  if (getKey === void 0) {
    getKey = dashToCamel;
  }

  if (getValue === void 0) {
    getValue = identity;
  }

  return function (context) {
    var arrayData = context.split(suffix).map(function (str) {
      return str.split(infix);
    });
    if (!arrayData[-1]) arrayData.pop(); // the last value will often be an empty string

    var object = {};
    arrayData.forEach(function (_ref) {
      var initialKey = _ref[0],
          initialValue = _ref[1];
      var keyOrKeys = getKey(initialKey);
      var value = getValue(initialValue);

      if (Array.isArray(keyOrKeys)) {
        keyOrKeys.forEach(function (key) {
          return assignOver(object, key, value);
        });
      } else {
        assignOver(object, keyOrKeys, value);
      }
    });
    return object;
  };
};

var parseViewBoxAndStyle = function parseViewBoxAndStyle(svgData, output) {
  var viewBoxString = apply(function (match) {
    return match[1];
  }, viewBoxMatcher.exec(svgData));
  var styleString = apply(function (match) {
    return match[1];
  }, styleMatcher.exec(svgData));

  if (viewBoxString) {
    var _viewBoxString$split = viewBoxString.split(' '),
        x = _viewBoxString$split[0],
        y = _viewBoxString$split[1],
        width = _viewBoxString$split[2],
        height = _viewBoxString$split[3];

    output.viewBox = {
      x: x,
      y: y,
      width: width,
      height: height
    };
  }

  if (styleString) {
    var objectifyStyleAttributes = objectify(':', ';');

    var getClassNames = function getClassNames(key) {
      return key.split(',').map(function (className) {
        return className.slice(1);
      });
    };

    var objectifyStyles = objectify('{', '}', getClassNames, objectifyStyleAttributes);
    output.style = objectifyStyles(styleString);
  }
};
/**
 * parse - primary export; converts an SVG string to a Javascript object.
 */


export var parse = function parse(svgData) {
  if (typeof svgData !== 'string') {
    var message = 'SVG data should be in string format';
    console.log(message);
    return new Error(message);
  }

  var output = {
    shapes: []
  };
  parseViewBoxAndStyle(svgData, output);
  svgData.match(shapeMatcher).forEach(function (shapeString) {
    var _shapeString$replace$ = shapeString.replace(spaceSplitter, '\n').split('\n'),
        tagName = _shapeString$replace$[0],
        attrStrings = _shapeString$replace$.slice(1);

    var attributes = {};
    var isFrame = false;
    attrStrings.forEach(function (attrString) {
      var _attrString$split = attrString.split(/=/),
          key = _attrString$split[0],
          value = _attrString$split[1];

      var camelKey = dashToCamel(key);
      var trimmedValue = value.slice(1, -1);

      if (camelKey === 'dataName' && trimmedValue.toLowerCase() === 'frame') {
        isFrame = true;
      } else if (key !== 'id') {
        attributes[camelKey === 'class' ? 'className' : camelKey] = trimmedValue;
      }
    });

    if (isFrame) {
      output.frame = attributes;
    } else if (attributes.dataName) {
      output.shapes.push({
        tagName: tagName.slice(1),
        attributes: attributes
      });
    }
  });
  console.log("Parsed SVG data; " + output.shapes.length + " shapes found.");
  return output;
};
export var parseLabels = function parseLabels(svgData) {
  if (typeof svgData !== 'string') {
    var message = 'SVG data should be in string format';
    console.log(message);
    return new Error(message);
  }

  var labels = [];
  var cleanLabels = [];
  var removedLabels = [];
  var output = {
    shapes: []
  };
  parseViewBoxAndStyle(svgData, output);
  var dimsRegex = /\d+[\u2018\u2019'][ -]?(\d+[\u201c\u201d"])? *[xX]/;
  var split = svgData.split('</text>');

  if (split.length > 1) {
    split.pop();
    split.forEach(function (splitString) {
      var textTag = splitString.substring(splitString.indexOf('<text'));
      var contents = textTag.substring(textTag.indexOf('>') + 1);
      var openingTspans = contents.match(/<\s*tspan[^>]*>/g);

      if (openingTspans !== null) {
        var lastTspanY = '0';
        openingTspans.forEach(function (tspan) {
          if (tspan.indexOf(' y="')) {
            var newTspanY = tspan.match(/ y="(.*)"/);

            if (newTspanY && newTspanY[1] !== lastTspanY) {
              contents = contents.replace(/<\s*tspan[^>]*>/, ' ');
              lastTspanY = newTspanY[1];
              return;
            }
          } // this will only run if there is no ' y="' or if the tspan's y position
          // is different from the y position of the previous text


          contents = contents.replace(/<\s*tspan[^>]*>/, '');
        });
      }

      contents = contents.replace(/<\s*\/\s*tspan\s*>/g, '').replace(/ +/g, ' ').trim();
      var attributes = textTag.substring(6, textTag.indexOf('>'));

      if (attributes.indexOf('data-name="dims"') >= 0) {
        removedLabels.push(contents);
        return;
      }

      labels.push(contents);
    });
  }

  if (labels.length) {
    labels.forEach(function (label) {
      var match = label.match(dimsRegex);

      if (match) {
        if (match.index !== 0) {
          cleanLabels.push(label.substring(0, match.index).trim());
          removedLabels.push(label.substring(match.index).trim());
        } else {
          removedLabels.push(label);
        }
      } else {
        cleanLabels.push(label.trim());
      }
    });
  }

  var tagSplit = svgData.split('</text>');

  if (tagSplit.length > 1) {
    tagSplit.pop();
    tagSplit.forEach(function (splitString) {
      var textTag = "" + splitString.substring(splitString.indexOf('<text'));
      var attributesString = textTag.substring(6, textTag.indexOf('>'));
      var attrStrings = attributesString.replace(spaceSplitter, '\n').split('\n');
      var content = textTag.substring(textTag.indexOf('>') + 1);
      var attributes = {};
      attrStrings.forEach(function (attrString) {
        var _attrString$split2 = attrString.split(/=/),
            key = _attrString$split2[0],
            value = _attrString$split2[1];

        var camelKey = dashToCamel(key);
        var trimmedValue = value.slice(1, -1);

        if (key !== 'id') {
          attributes[camelKey === 'class' ? 'className' : camelKey] = trimmedValue;
        }
      });
      var shape = {
        tagName: 'text',
        attributes: attributes,
        content: content
      };
      output.shapes.push(Object.assign({}, shape, {
        hash: objectHash(shape)
      }));
    });
  }

  console.log("Parsed SVG data; " + cleanLabels.length + " labels found.");
  return {
    cleanLabels: cleanLabels,
    removedLabels: removedLabels,
    output: output
  };
};
export var readSvgViewBox = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var svgAsText, viewBoxString;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url).then(function (response) {
              return response.text();
            });

          case 2:
            svgAsText = _context.sent;
            viewBoxString = apply(function (match) {
              return match[1];
            }, viewBoxMatcher.exec(svgAsText));

            if (!viewBoxString) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", viewBoxString);

          case 6:
            return _context.abrupt("return", null);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readSvgViewBox(_x) {
    return _ref2.apply(this, arguments);
  };
}();